<template>
    <div class="uav-projects-container">
        
      <!-- Filter Bar -->
      <div class="filter-bar">
        <div class="filter-left">
          <Input 
            v-model="searchQuery" 
            placeholder="搜索项目名称或描述..." 
            clearable 
            search
            style="width: 300px"
            @on-search="handleSearch"
            @on-clear="handleSearch"
            prefix="ios-search"
          />
        
        </div>
  
        <div class="filter-right">
          <Button type="primary" icon="md-add" @click="handleAdd">
            新建项目
          </Button>
        </div>
      </div>
  
      <!-- Table -->
      <div class="table-container">
        <BaseTable
          ref="projectTable"
          :columns="columns"
          :data="projects"
          :loading="loading"
          :page="page"
          :page-size="pageSize"
          :count="total"
          border
          @event="handleTableEvent"
          @on-page-change="handlePageChange"
          @on-page-size-change="handlePageSizeChange"
        />
      </div>
  
      <!-- Create/Edit Modal -->
      <Modal
        v-model="modalVisible"
        :title="modalTitle"
        width="600"
        @on-ok="handleSubmit"
        :loading="confirmLoading"
      >
        <Form ref="formRef" :model="formData" :rules="rules" :label-width="100">
          <FormItem label="场景名称" prop="name">
            <Input 
              v-model="formData.name" 
              placeholder="请输入场景名称"
              maxlength="100"
              show-word-limit
            />
          </FormItem>

          <FormItem label="拍摄日期" prop="date">
           <BaseDate v-model="formData.date" placeholder="请选择拍摄日期" />
          </FormItem>

          <FormItem label="项目名称" prop="zzl_project_id" v-if="!pid">
            <Select v-model="formData.zzl_project_id" placeholder="请选择关联项目" :disabled="formData.id?true:false" filterable clearable>
              <template v-for="p in zzlProjects">
                <Option :value="p.id" :key="p.id">{{ p.name }}</Option>
              </template>
            </Select>
          </FormItem>
  
          
          <FormItem label="备注" prop="description">
            <Input
              type="textarea"
              v-model="formData.description"
              placeholder="请输入项目描述"
              :rows="4"
              maxlength="1024"
              show-word-limit
            />
          </FormItem>
  
        </Form>
      </Modal>
    </div>
  </template>
  
  <script>
  import moment from 'moment';
  import { mapGetters } from 'vuex';
  export default {
    name: 'UavProjects',
    data() {
      return {
        projects: [],
        uid: '',
        is_admin:false,
        pid: '',
        searchQuery: '',
        filterStatus: 'all',
        loading: false,
        page: 1,
        pageSize: 20,
        total: 0,
        modalVisible: false,
        modalTitle: '新建项目',
        confirmLoading: false,
        currentId: null,
        
        formData: this.getInitialFormData(),
        zzlProjects:[],
        rules: {
          name: [
            { required: true, message: '请输入项目名称', trigger: 'blur' },
            { min: 2, max: 100, message: '项目名称长度在2-100个字符', trigger: 'blur' }
          ],
          description: [
            { max: 1024, message: '描述不能超过1024个字符', trigger: 'blur' }
          ]
        },
        
        columns: [
          {
            type: 'index',
            width: 70,
            title: '序号',
            align: 'center'
          },
          ...!this.pid?[{
            title:'项目',
            width:'200',
            key:'projectName',
            render:(h,{row})=>{
              if(!row.zzl_project_id)
                return h('span', '-')
              let project = this.zzlProjects.find(p=>p.id == row.zzl_project_id)
              if(project)
                return h('a', {
                  on: {
                    click: () => this.RouteTo(`/tools/uav-projects/?uid=${this.uid}&pid=${row.zzl_project_id}`,true)
                  }
                }, project.name)
              else
                return h('span','项目不存在')
            }
          }]:[],
          {
            title:'拍摄日期',
            width:'120',
            key:'date',
            type:'time',
            option:{
              type:'date'
            }
          },
          {
            title: '场景名称',
            key: 'name',
            minWidth: 200,
            render: (h, { row }) => {
              return h('div', {
                style: {
                  fontWeight: '600',
                  color: 'var(--text2)',
                  cursor: 'pointer',
                  textAlign:'left',
                  padding:"0 10px"
                },
                on: {
                  click: () => this.handleView(row)
                }
              },[h('a',row.name)]);
            }
          },
         
          {
            title: '照片数量',
            key: 'view_count',
            width: 120,
            align: 'center',
            render: (h, { row }) => {
              const count = row.view_count || 0;
              return h('div', {
                style: {
                  display: 'inline-flex',
                  alignItems: 'center',
                  padding: '4px 12px',
                  background: count > 0 ? 'var(--primary-light)' : 'var(--bg2)',
                  borderRadius: '12px',
                  color: count > 0 ? 'var(--primary)' : 'var(--text3)',
                  fontWeight: '600',
                  fontSize: '13px'
                }
              }, [
                h('BaseIcon', {
                  props: { icon: 'ios-images' },
                  style: { marginRight: '4px', fontSize: '16px' }
                }),
                h('span', count)
              ]);
            }
          },
          {
            key:'views_count',
            title:'浏览量',
            width:100,
            align:'center',
            render: (h, { row }) => {
              return h('span', row.views_count || 0);
            }
          },
          {
            title: '创建时间',
            key: 'created_at',
            type: 'time',
            width: 180,
            sortable: true
          },
          {
            title: '创建人',
            key: 'created_by',
            type: 'user',
            width: 180,
            sortable: true
          },
          {
            title: '操作',
            key: 'action',
            minWidth: 320,
            fixed:"right",
            align: 'center',
            render: (h, { row }) => {
              let buttonView =  h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                  },
                  style: {
                    color: '#fff'
                  },
                  on: {
                    click: () => this.handleView(row)
                  }
                }, '查看')
              let btnEdit = h('Button', {
                  props: {
                    type: 'default',
                    size: 'small',
                  },
                  on: {
                    click: () => this.handleEdit(row)
                  }
                }, '修改')

              let btnDesign =  h('Button', {
                  props: {
                    type: 'success',
                    size: 'small',
                  },
                  on: {
                    click: () => this.handleDesign(row)
                  }
                }, '编辑')
              let btnDelete = h('Button', {
                  props: {
                    type: 'error',
                    size: 'small',
                    icon: 'ios-trash'
                  },
                  style: {
                    color: '#fff'
                  },
                  on: {
                    click: () => this.handleDelete(row)
                  }
                }, '删除')
              let btnShare = h('Button', {
                  props: {
                    type: 'info',
                    size: 'small',
                  },
                  on: {
                    click: () => this.handleShare(row)
                  }
                }, '分享')
              return h('div', {
                style: {
                  display: 'flex',
                  gap: '6px',
                  justifyContent: 'center'
                }
              }, 
               this.is_admin || this.session.id == row.created_by ? [buttonView,btnEdit,btnDesign,btnDelete,btnShare] : [buttonView,btnShare]
                
              );
            }
          }
        ]
      };
    },
    metaInfo:{
      title:"全景照片场景管理"
    },
    watch: {
    $route: {
      handler(v) {
        const {uid,pid} = v.query;
        if (uid) {
          this.uid = uid;
          this.pid = pid;
        } else {
          this.is_ready = true;
        }
      },
      deep: true,
      immediate: true,
    },
  },
    mounted() {
      this.$api.afterLogin(()=>{
        this.fetchData()
        this.getZZLProjects()
      });
    },
    
    computed:{
      ...mapGetters('session',['session']),
    },

    methods: {
      handleShare (row){
        let baseUrl = location.origin; // 获取当前域名地址和协议
            let shareUrl = baseUrl + `/tools/${row.id}/uav720`
            if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
                navigator.clipboard.writeText(shareUrl)
                    .then(() => {
                        this.Success('已复制分享地址!');
                    })
                    .catch(() => {
                        this.Error('复制失败，请手动复制');
                    });
            } else {
                // 如果 clipboard API 不可用，回退到 prompt 让用户手动复制
                try {
                    // 尝试使用旧版 document.execCommand
                    const textArea = document.createElement("textarea");
                    textArea.value = shareUrl;
                    // 使textarea不可见
                    textArea.style.position = "fixed";
                    textArea.style.opacity = "0";
                    document.body.appendChild(textArea);
                    textArea.select();
                    document.execCommand("copy");
                    document.body.removeChild(textArea);
                    this.Success('已复制分享地址!');
                } catch (e) {
                    // 仍然不支持时，弹窗让用户手动复制
                    window.prompt("请手动复制分享地址：", shareUrl);
                }
            }
      },
      getZZLProjects(){
        this.$api.get('logined_zzl/projects').then((res)=>{
          this.zzlProjects = res.data.data;
        });
      },
      
      getInitialFormData() {
        return {
          name: '',
          description: '',
          project_id: '',
          date:moment().format(),
          zzl_project_id: ''
        };
      },
      
      async fetchData() {
        this.loading = true;
        try {
          const params = {
            page: this.page,
            page_size: this.pageSize
          };
          
          if (this.searchQuery) {
            params.search = this.searchQuery;
          }
          
          if (this.pid) {
            params.zzl_project_id = this.pid;
          }
          
          const response = await this.$api.get('/uav/projects', { params });
          this.projects = response.data.data || [];
          this.total = response.data.total || this.projects.length;
        } catch (error) {
          this.$Message.error('获取项目列表失败');
          console.error(error);
        } finally {
          this.loading = false;
        }
      },
      
      handleSearch() {
        this.page = 1;
        this.fetchData();
      },
      
      handleFilter() {
        this.page = 1;
        this.fetchData();
      },
      
      handlePageChange(page) {
        this.page = page;
        this.fetchData();
      },
      
      handlePageSizeChange(pageSize) {
        this.pageSize = pageSize;
        this.page = 1;
        this.fetchData();
      },
      
      handleTableEvent(e) {
        const { type, data } = e;
        switch (type) {
          case 'page-change':
            this.handlePageChange(data);
            break;
          case 'page-size-change':
            this.handlePageSizeChange(data);
            break;
        }
      },
      
      handleAdd() {
        this.modalTitle = '新建项目';
        this.formData = this.getInitialFormData();
        this.currentId = null;
        this.modalVisible = true;
      },
      
      handleView(row) {
        // 跳转到项目详情页面
        let baseUrl = location.origin;
        this.RouteTo(baseUrl + `/core/uav-projects/${row.id}/view?uid=${this.uid}`,true);
      },
      
      handleEdit(row) {
        this.modalTitle = '编辑项目';
        this.formData = {
          name: row.name,
          description: row.description || '',
          project_id: row.project_id || '',
          zzl_project_id: row.zzl_project_id || ''
        };
        this.currentId = row.id;
        this.modalVisible = true;
      },

      handleDesign(row){
        let baseUrl = location.origin;
        this.RouteTo(baseUrl + `/core/uav-projects/${row.id}/editor?uid=${this.uid}`,true);
      },
      
      handleDelete(row) {
        this.$Modal.confirm({
          title: '确认删除',
          content: `确定要删除项目"${row.name}"吗？此操作不可恢复。`,
          okText: '确认删除',
          cancelText: '取消',
          loading: true,
          onOk: async () => {
            try {
              await this.$api.delete(`/uav/projects/${row.id}`);
              this.$Modal.remove();
              this.$Message.success('删除成功');
              this.fetchData();
            } catch (error) {
              this.$Modal.remove();
              this.$Message.error('删除失败');
              console.error(error);
            }
          }
        });
      },
      
      async handleSubmit() {
        try {
          await this.$refs.formRef.validate();
          this.confirmLoading = true;
          
          if (this.currentId) {
            // 更新
            await this.$api.patch(`/uav/projects/${this.currentId}`, this.formData);
            this.$Message.success('更新成功');
          } else {
            // 新建
            await this.$api.post('/uav/projects', this.formData);
            this.$Message.success('创建成功');
          }
          
          this.modalVisible = false;
          this.fetchData();
        } catch (error) {
          if (error.fields) {
            // 表单验证失败
            return;
          }
          this.$Message.error(error.message || '提交失败');
          console.error(error);
        } finally {
          this.confirmLoading = false;
        }
      }
    }
  };
  </script>
  
  <style scoped lang="less">
  .uav-projects-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    background: var(--bg);
  }
  
  .page-header {
    background: linear-gradient(135deg, var(--primary) 0%, var(--primary-dark, #2b7fd6) 100%);
    padding: 24px 28px;
    border-radius:0;
    border-bottom: 1px solid var(--border);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    margin:0;
    
    .header-content {
      display: flex;
      align-items: center;
      color: #fff;
      
      .page-title {
        margin: 0;
        font-size: 22px;
        font-weight: 600;
        color: #fff;
        line-height: 1.3;
      }
      
      .page-subtitle {
        margin: 4px 0 0 0;
        font-size: 13px;
        color: rgba(255, 255, 255, 0.85);
        line-height: 1;
      }
    }
  }
  
  .filter-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    background: #fff;
    border-bottom: 1px solid var(--border);
    
    .filter-left {
      display: flex;
      align-items: center;
    }
    
    .filter-right {
      display: flex;
      align-items: center;
      gap: 10px;
    }
  }
  
  .table-container {
    flex: 1;
    padding: 16px 20px;
    overflow: hidden;
    background: var(--bg);
  }
  
  </style>
  
  